import { Helmet } from 'react-helmet';

const siteMetadata = {
  title: 'KOC CMS',
  description: '',
  author: '',
};

function Seo({
  description = '',
  lang = 'en',
  meta = [],
  title,
}: {
  description?: string;
  lang?: string;
  meta?: any;
  title?: string;
}) {
  const metaDescription = description || siteMetadata.description;
  const defaultTitle: string = siteMetadata.title;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : undefined}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: siteMetadata.author || '',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <body id="tailwind-important" />
    </Helmet>
  );
}

export default Seo;
